module.exports = __webpack_public_path__ + "img/no_data.7b5e3694.png";